if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.initColorFilter();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      /* ===== Photos par couleur (Nelia) =====
         Chaque photo dont le texte alternatif (alt) = nom de la couleur
         n'apparait que quand cette couleur est selectionnee.
         Les photos sans alt restent toujours visibles. */
      initColorFilter() {
        if (!document.getElementById('nelia-color-filter-css')) {
          const style = document.createElement('style');
          style.id = 'nelia-color-filter-css';
          style.textContent = '.nelia-color-hidden{display:none !important;}';
          document.head.appendChild(style);
        }
        const sectionId = (this.id || '').replace('MediaGallery-', '').replace('-duplicate', '');
        const run = () => setTimeout(() => this.applyColorFilter(sectionId), 0);
        const bind = () => {
          const picker = document.querySelector(
            `variant-radios[data-section="${sectionId}"], variant-selects[data-section="${sectionId}"]`
          );
          if (!picker) return;
          picker.addEventListener('change', run);
          this.colorPicker = picker;
          run();
        };
        document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', bind) : bind();
      }

      normColor(value) {
        return (value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .trim();
      }

      getSelectedColor() {
        const picker = this.colorPicker;
        if (!picker) return null;
        const re = /couleur|color|colour|coloris/i;
        for (const fs of picker.querySelectorAll('fieldset')) {
          const legend = fs.querySelector('legend');
          const checked = fs.querySelector('input:checked');
          if (!checked) continue;
          if ((legend && re.test(legend.textContent)) || re.test(checked.name || '')) return checked.value;
        }
        for (const sel of picker.querySelectorAll('select')) {
          const label = sel.id ? picker.querySelector(`label[for="${sel.id}"]`) : null;
          if ((label && re.test(label.textContent)) || re.test(sel.name || '')) return sel.value;
        }
        return null;
      }

      mediaColor(item) {
        const img = item.querySelector('img[alt]');
        return img ? this.normColor(img.getAttribute('alt')) : '';
      }

      applyColorFilter() {
        const viewer = this.elements.viewer;
        if (!viewer) return;
        const color = this.normColor(this.getSelectedColor());
        const items = Array.from(viewer.querySelectorAll('[data-media-id]'));
        const hasMatch = color && items.some((el) => this.mediaColor(el) === color);
        const hiddenIds = new Set();

        items.forEach((el) => {
          const tag = this.mediaColor(el);
          const hide = hasMatch && tag !== '' && tag !== color;
          el.classList.toggle('nelia-color-hidden', hide);
          if (hide) hiddenIds.add(el.dataset.mediaId);
        });

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
            thumb.classList.toggle('nelia-color-hidden', hiddenIds.has(thumb.dataset.target));
          });
        }

        [viewer, this.elements.thumbnails].forEach((slider) => {
          if (!slider) return;
          if (slider.slider) slider.slider.scrollTo({ left: 0 });
          if (typeof slider.resetPages === 'function') slider.resetPages();
        });
      }
      /* ===== fin Photos par couleur ===== */

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
      //  window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
